import { IBaseEditorProps, BaseEditor } from "./BaseEditor";
import { IRadiosSpecificProps } from "./Radios";
import * as React from "react";
import { RadiosFactory } from "./Factories/RadiosFactory";
import { isNotEmpty } from "./Validation/RawValueRules";
import { Guid } from "../Utils/Guid";
import * as classNames from "classNames";
import { IRadiosEditorProps } from "./RadiosEditor";

export interface IRadioGroupProps<TOption>
    extends IBaseEditorProps,
        IRadiosSpecificProps<TOption>,
        IRadiosEditorProps<TOption> {}

export class RadioGroup<TOption> extends BaseEditor<IRadiosEditorProps<TOption>> {
    constructor(props: IRadiosEditorProps<TOption>) {
        super(props);
    }

    public render(): JSX.Element {
        const wrapperCss = classNames("radio-group", this.props.cssWrapper, {
            error: this.state.typingFinished && !this.state.isValid && !this.state.isValidOutside,
            valid: this.state.typingFinished && this.state.isValid && this.state.isValidOutside,
        });

        return (
            <div className={wrapperCss} ref={(elem: HTMLElement) => (this.wrapperRef = elem)}>
                <fieldset className={wrapperCss}>
                    {this.getDescription()}
                    {this.getInput()}
                    {this.getValidationErrorsContainer()}
                </fieldset>
            </div>
        );
    }

    public componentDidMount() {
        this.bindLabelToInput();
    }

    protected getInput() {
        const Radios = RadiosFactory.create<TOption>();
        return (
            <Radios
                {...(this.props as any)}
                id={this.state.inputGroupId}
                onValidationResultChange={(isValid: boolean, errors: string[], showValidationMessages: boolean) =>
                    this.onValidationResultChange(isValid, errors, showValidationMessages)
                }
                cssInput={"rb-input"}
                radioLabelCss={this.props.radioLabelCss || "radio-button radio-tick-panel"}
                optionsLabelCss={"rb-label"}
                selectedRadioCss={"rb-design"}
            />
        );
    }

    private getDescription(): JSX.Element {
        if (!this.props.label) {
            return null;
        }

        return (
            <legend className="control-label">
                <span id={this.state.inputGroupId}>{this.props.label}</span>
                {this.getTooltip()}
            </legend>
        );
    }

    private bindLabelToInput() {
        let propId: string = null;
        if (this.props.hasOwnProperty("id")) {
            propId = this.props.id;
        }

        const id = isNotEmpty(propId) ? propId : Guid.getNext();
        this.setState({ inputGroupId: id });
    }
}
